<template>
<section class="flex flex-col bg-gray-50 h-[100dvh] pt-20">
  <div class="flex flex-1 flex-col px-6 lg:px-8">
    <div class="flex justify-center sm:mx-auto sm:w-full sm:max-w-sm">
      <img width="145" height="78" src="@/assets/qstar-logo.svg" alt="qstar-logo">
    </div>
    <div v-if="!showForgotPassword" class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
      <form class="space-y-6" action="#" method="POST">
        <div>
          <label for="userName" class="block text-sm font-medium leading-6 text-secondary">Arbejdsnummer</label>
          <div>
            <input inputmode="numeric" id="userName" name="userName" type="text" v-model="loginForm.userName" autocomplete="userName" required class="peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6" />
            <span v-if="loginForm.validateState === 500" class="m-2 text-sm text-error peer-[&:not(:focus):invalid]:block">Angiv et gyldigt arbejdsnummer</span>
          </div>
        </div>

        <div>
          <label for="password" class="block text-sm font-medium leading-6 text-secondary">Adgangskode</label>
          <div>
            <input id="password" name="password" type="password" v-model="loginForm.password" autocomplete="current-password" required class="peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6" />
            <span v-if="loginForm.loginState === 500" class="m-2 text-sm text-error peer-[&:not(:focus):invalid]:block">Forkerte adgangsoplysninger</span>
          </div>
        </div>

        <div class="xs:flex-row xs:space-y-0 flex flex-col items-center justify-between space-y-2 px-2">
          <div class="flex items-center">
            <input id="remember-me" name="remember-me" type="checkbox" class="h-4 w-4 rounded border-gray-300 text-secondary focus:ring-secondary" />
            <label for="remember-me" class="ml-3 block text-sm text-gray-900">Husk mig</label>
          </div>

          <div class="text-sm">
            <a @click="handleClickForgotPassword()" class="font-medium text-secondary underline cursor-pointer hover:text-primary">Glemt din adgangskode?</a>
          </div>
        </div>

        <div>
          <span @click="login" class="flex w-full justify-center text-center cursor-pointer rounded-md h-10 bg-secondary px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary"
          :class="{'opacity-50' : loginLoading}">
            <template v-if="loginLoading">
              <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </template>
            <template v-else>
              Log ind
            </template>
          </span>
        </div>
      </form>
    </div>
    <div v-else class="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
      <form class="space-y-6" action="#" method="POST">
        <div>
          <label for="userName" class="block text-sm font-medium leading-6 text-secondary">Arbejdsnummer</label>
          <div>
            <input id="userName" name="userName" type="text" v-model="forgotPasswordForm.userName" autocomplete="userName" required class="peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6" />
          </div>
        </div>

        <div>
          <label for="password" class="block text-sm font-medium leading-6 text-secondary">Mobilnummer</label>
          <div>
            <input id="password" name="phone" type="text" v-model="forgotPasswordForm.phoneNumber" autocomplete="current-password" required class="peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6" />
            <span v-if="forgotPasswordForm.responseState === 500" class="m-2 text-sm text-error peer-[&:not(:focus):invalid]:block">Ugyldige oplysninger</span>
          </div>
        </div>

        <div>
          <span @click="handleSubmitForgotPassword()" class="flex w-full cursor-pointer justify-center h-10 rounded-md bg-secondary px-3 py-2 font-medium leading-6 text-white shadow-sm hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary"
          :class="{'opacity-50': forgotPasswordLoading}">
            <template v-if="forgotPasswordLoading">
              <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            </template>
            <template v-else>
              Send adgangskode på SMS
            </template>
          </span>
        </div>

        <div class="xs:flex-row xs:space-y-0 flex flex-col items-center text-center justify-between space-y-2 px-2">
          <div class="text-sm w-full text-center">
            <a @click="handleClickBackToLogin()" class="font-medium text-secondary cursor-pointer underline hover:text-primary">Tilbage til login</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>

</template>

<script lang="ts">
import { defineComponent } from 'vue'
import applicationUserManager from '../core/applicationusermanager'
import loginRepository from '../repositories/authenticationRepository'
import checkSecMixin from '../core/checksec'

export default defineComponent({
  name: 'loginView',
  data: () => ({
    loginForm: {
      userName: '',
      password: '',
      returnUrl: '',
      rememberMe: false,
      validateState: 0,
      loginState: 0
    },
    forgotPasswordForm: {
      userName: '',
      phoneNumber: '',
      responseState: 0
    },
    showForgotPassword: false,
    loginLoading: false,
    forgotPasswordLoading: false
  }),
  mixins: [checkSecMixin],
  components: {
  },
  async beforeMount () {
    const user = await applicationUserManager.getUserInfo()
    if (user) {
      this.$router.push('/')
    }
  },
  watch: {
    'loginForm.userName' (newUserName) {
      this.forgotPasswordForm.userName = newUserName
    },
    'forgotPasswordForm.userName' (newUserName) {
      this.loginForm.userName = newUserName
    }
  },
  methods: {
    async login () {
      if (this.loginLoading === true) {
        return
      }
      this.loginLoading = true
      try {
        console.log(await loginRepository.validate(this.loginForm))
        this.loginForm.validateState = 200
      } catch (error) {
        console.error(error)
        this.loginForm.validateState = 500
        return
      } finally {
        this.loginLoading = false
      }

      this.loginLoading = true
      try {
        await applicationUserManager.login(this.loginForm.userName, this.loginForm.password)
        const user = await applicationUserManager.getUserInfo()
        if (user) {
          this.$router.push('/')
        } else {
          this.loginForm.loginState = 500
        }
      } catch (error) {
        this.loginForm.loginState = 500
      } finally {
        this.loginLoading = false
      }
    },
    handleClickForgotPassword () {
      this.showForgotPassword = true
    },
    async handleSubmitForgotPassword () {
      if (this.forgotPasswordLoading === true) {
        return
      }
      this.forgotPasswordLoading = true
      try {
        await loginRepository.forgot(this.forgotPasswordForm)
        this.showForgotPassword = false
        this.forgotPasswordForm.responseState = 200
      } catch (error) {
        this.forgotPasswordForm.responseState = 500
        console.log(error)
      } finally {
        this.forgotPasswordLoading = false
      }
    },
    handleClickBackToLogin () {
      this.showForgotPassword = false
    }
  }
})
</script>
